// eslint-disable-next-line import/prefer-default-export
export const FORM_UPDATE = 'FORM_UPDATE';
export const FORM_CLEAR = 'FORM_CLEAR';
